<template>
  <div class="slide" id="slide_share" v-if="isVisibleSlide('share')">
    <div class="slide-content">
      <div class="container">
        <div class="row">
          <div class="col-md-12 results-content">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-5">
                  <p class="thanks">Ok - Just click below to share…</p>
                  <div class="buttons-container">
                    <button class="btn-default btn-facebook" @click="facebookShare()">Share on Facebook</button>
                    <button class="btn-default btn-whatsapp" @click="whatsappShare()">Share on Whatsapp</button>
                  </div>
                  <div class="btn-skip-container">
                    <button class="btn btn-skip desktop-only" @click="gotoSlide('final'); analytics('share', 'clicked skip');">Skip >></button>
                  </div>
                </div>
                <div class="col-md-7">
                  <div class="share-preview">
                    <img src="../assets/img/shareControl.png" v-if="$store.state.variants.facebookImg == 0">
                    <img src="../assets/img/shareV1.png" v-if="$store.state.variants.facebookImg == 1">
                    <div class="share-preview-text" v-if="$store.state.variants.facebookText == 0">
                      <div class="share-preview-title" v-if="$store.state.result == 7">I Just Scored {{$store.state.result}}/7 In This First Aid Quiz - Can You Match My Score? >></div>
                      <div class="share-preview-title" v-else>I Just Scored {{$store.state.result}}/7 In This First Aid Quiz - Can You Beat My Score? >></div>
                      <div class="share-preview-description">Try now - it takes two minutes. </div>
                    </div>
                    <div class="share-preview-text" v-if="$store.state.variants.facebookText == 1">
                      <div class="share-preview-title">How Good Is Your First Aid Knowledge? Test Your Skills With This Quick Quiz >></div>
                      <div class="share-preview-description">Hardly anyone can get all 7 right. Are you one of them?</div>
                    </div>
                  </div>
                  <button class="btn btn-skip mobile-only" @click="gotoSlide('final'); analytics('share', 'clicked skip');">Skip >></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Share',
  props: ['gotoSlide', 'isVisibleSlide', 'analytics'],
  data () {
    return { 
    }
  },
  methods: {
    facebookShare() {
      var variantText = this.$store.state.variants.facebookText;
      var variantImg = this.$store.state.variants.facebookImg;
      var score = this.$store.state.result;
      var here = window.location.href.split('?')[0]
      var toShareUrl = here + 'share.php/'+score+'/'+variantText+'/'+variantImg+'/?utm_campaign=tuc-first-aid&utm_source=facebook_share_variants_'+variantText+'_'+variantImg+'&utm_medium=facebook&source=facebook';
      var shareURL = 'https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(toShareUrl);
      window.open(shareURL, '_blank', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=250,top=300,left=300');
      this.$store.state.shared = true;
      this.gotoSlide('final');
      this.analytics('share', 'clicked facebook share v_' + variantText + '_' + variantImg);
      return;
    },
    whatsappShare() {
      var variant = this.$store.state.variants.whatsapp;
      var score = this.$store.state.result;
      var here = window.location.href.split('?')[0] + '?utm_campaign=tuc-first-aid&utm_source=whatsapp_share_variant_'+ variant +'&utm_medium=whatsapp';
      var shareText = 'Hi, I just scored '+ score +' out of 7 in this quiz on first aid - can you beat my score? ' + here;
      if(score == 7){
        shareText = 'Hi, I just scored '+ score +' out of 7 in this quiz on first aid - can you match my score? ' + here;
      }
      if(variant == 1){
        shareText = 'How good are your first aid skills? Take this quiz to find out: ' + here;
      }
      var shareURL = 'https://api.whatsapp.com/send?text='+encodeURIComponent(shareText);
      window.open(shareURL, '_blank');
      this.$store.state.shared = true;
      this.gotoSlide('final');
      this.analytics('share', 'clicked whatsapp share v_'+ variant );
      return;
    }
  }
}
</script>

<style scoped lang="scss">
.slide-content {
  .container {
    box-shadow: 0px 0px 10px rgba(70,70,70,0.1);
    text-align: center;
    @media only screen and (max-width: 768px) {
      box-shadow: none;
    }
    .content-wrapper {
      margin: 100px auto;
      max-width: 700px;
      @media only screen and (max-width: 768px) {
        box-shadow: none;
        margin: 30px auto;
      }
    }
  }
  .thanks {
    font-size: 17px;
    font-weight: 600;
    text-align: left;
  }
}
.buttons-container {
  margin-top: 25px;
  text-align: left;
  button {
    font-size: 17px;
    padding: 17px 35px;
    width: auto;
    margin-bottom: 10px;
    border: none;
    border-radius: 0px;
    color: #fff;
    cursor: pointer;
    img {
      vertical-align: middle;
      height: 20px;
      position: relative;
      top: -2px;
      margin-right: 10px;
      @media only screen and (max-width: 576px) {
        margin-right: 30px;
      }
    }
    &.btn-facebook {
      background: #4469b0;
      &:hover {
        background: #3459a0;
      }
    }
    &.btn-whatsapp {
      background: #5fd26a;
      display: none;
      &:hover {
        background: #4fc25a;
      }
      @media only screen and (max-width: 767px) {
        display: inline-block;
      }
    }
    @media only screen and (max-width: 767px) {
      width: 100%;
    }
  }
}
.btn-skip-container {
  text-align: left;
  .btn-skip {
    display: inline-block;
    margin-top: 20px;
  }
}
.mobile-only {
  .btn-skip {
    margin-top: 20px;
  }
}
.share-preview {
  width: 430px;
  background: #f1f0ef;
  margin: 0px auto 20px auto;
  max-width: 100%;
  //border: 1px solid #979797;
  @media only screen and (max-width: 767px) {
    margin: 10px auto 10px auto;
  }
  img {
    width: 100%;
  }
  .share-preview-text {
    padding: 20px;
    text-align: left;
    font-size: 15px;
    font-family: Arial, sans-serif;
    @media only screen and (max-width: 767px) {
      padding: 15px;
    }
  }
  .share-preview-title {
    font-weight: 600;
  }
}
</style>